import PropTypes from 'prop-types';
import React from 'react';
import { LOGO_LOADER } from '../../Assets/images';
import { LoaderStyled } from './LoaderStyled';
import Image from 'next/image';

const Loader = (props) => {
  return (
    <>
      {props?.isLoading && (
        <LoaderStyled className={props?.darkOverlay ? 'darkOverlay' : ''}>
          <div className={`loaderBox ${props?.withoutBackground ? 'withoutBG' : ''}`}>
            {props?.withoutLogo && (
              <div className="aster_logo">
                <Image src={LOGO_LOADER.src} alt="myAster" title="myAster" layout="fill" />
              </div>
            )}
            <div className={`threeDots ${props?.bigDots ? 'bigDots' : ''}`}>
              <div className="loaderDots dot1"></div>
              <div className="loaderDots dot2"></div>
              <div className="loaderDots dot3"></div>
            </div>
          </div>
        </LoaderStyled>
      )}
    </>
  );
};

Loader.propTypes = {
  isLoading: PropTypes.bool,
  darkOverlay: PropTypes.bool,
  withoutBackground: PropTypes.bool,
  withoutLogo: PropTypes.bool,
  bigDots: PropTypes.bool,
};

Loader.defaultProps = { darkOverlay: false, withoutLogo: true, bigDots: false };

export default Loader;
